import { Block, Image, Typography, palette, spacing, useBreakpoints } from "@stepapp/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { Platform, StyleSheet } from "react-native";

type Params = {
  name: string;
  icon: string;
  description?: Maybe<string>;
};

const IncludedInPriceItem = ({ name, description, icon }: Params) => {
  const { t } = useTranslation();
  const { mobileOnly, md } = useBreakpoints();

  return (
    <Block
      justifyCenter
      row
      marginBottom={md ? 2.25 : 1}
      paddingLeft={mobileOnly ? 1.75 : 3}
      paddingRight={mobileOnly ? 2.25 : 2.5}
      style={styles.content}
    >
      <Block alignCenter justifyCenter style={styles.icon}>
        <Image height={spacing.unit * 5} source={icon} width={spacing.unit * 5} />
      </Block>

      <Block justifyCenter flex={1} marginRight={2.5}>
        <Typography ellipsizeMode="tail" numberOfLines={1} type="white" variant="answerTitle">
          {name}
        </Typography>

        {!!description && (
          <Block marginTop={0.5}>
            <Typography ellipsizeMode="tail" numberOfLines={1} type="white" variant="lightLabel">
              {description}
            </Typography>
          </Block>
        )}
      </Block>

      <Block style={[styles.includedContainer, mobileOnly && styles.includedContainerMobile]}>
        <Typography type="white" variant={mobileOnly ? "smallLabel" : "bodyBold"} center>
          {t("screens.service.includedInService")}
        </Typography>
      </Block>
    </Block>
  );
};

export default React.memo(IncludedInPriceItem);

const styles = StyleSheet.create({
  content: {
    backgroundColor: palette.primary.accent,
    borderRadius: spacing.radius,
    overflow: "hidden",
    paddingVertical: spacing.unit * 2,
    ...Platform.select({
      default: {},
      web: {
        boxShadow:
          "0px 100px 80px rgba(0, 0, 84, 0.07), 0px 41.7776px 33.4221px rgba(0, 0, 84, 0.0503198), 0px 22.3363px 17.869px rgba(0, 0, 84, 0.0417275), 0px 12.5216px 10.0172px rgba(0, 0, 84, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 84, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 84, 0.0196802)",
      },
    }),
  },
  icon: {
    borderRadius: 50,
    height: 42,
    marginRight: 16,
    width: 42,
  },
  includedContainer: {
    backgroundColor: palette.secondary.wrongPink,
    borderRadius: spacing.radius,
    justifyContent: "center",
    paddingHorizontal: spacing.unit * 2,
  },
  includedContainerMobile: {
    flex: 1,
  },
});
